
export interface IOrgOfficeCodesRequest {
  orgId: number;
  sortColumn: string;
  sortOrder: number;
  pageNo: number;
  noOfRecords: number;
}


export class OrgOfficeCodesRequest implements IOrgOfficeCodesRequest {
  orgId: number;
  sortColumn: string;
  sortOrder: number;
  pageNo: number;
  noOfRecords: number;
  constructor(sortColumn: string, sortOrder: number) {
    this.sortColumn = sortColumn;
    this.sortOrder = sortOrder;
  }
}


export interface IOfficeDetails {
  officePostcodeId: number;
  officeName: string;
  officeAddress: string;
  latitude: number;
  longitude: number;
  placeId: string;
  orgId: number;
  userId: number;
  selected: boolean;
  isRowHighlighted: boolean;
  updatedOn: any;
  status: number;
  activationRequestStatus: number;
}


export class OfficeDetails implements IOfficeDetails {
  officePostcodeId: number = 0;
  officeName: string;
  officeAddress: string;
  latitude: number;
  longitude: number;
  placeId: string;
  orgId: number = 0;
  userId: number = 0;
  selected: boolean;
  isRowHighlighted: boolean;
  updatedOn: any;
  status: number = 1;
  activationRequestStatus: number = 0;
}

export interface ISaveOfficePostcodeResponse {
  responseString: string;
  updatedOn: number;

}


export class SaveOfficePostcodeResponse implements ISaveOfficePostcodeResponse {
  responseString: string;
  updatedOn: number;
}
export class ActivationRequestModel {
    id: number;
    type: number;
    subType: number = 0;
}
